// extracted by mini-css-extract-plugin
export var container = "_ii-0";
export var content = "_ii-3";
export var customerTitle = "_ii-4";
export var empty = "_ii-5";
export var gray = "_ii-6";
export var header = "_ii-7";
export var info = "_ii-8";
export var loading = "_ii-2";
export var loadingCard = "_ii-9";
export var oneLine = "_ii-a";
export var personName = "_ii-e";
export var pillContainer = "_ii-b";
export var selected = "_ii-1";
export var text = "_ii-c";
export var twoLines = "_ii-d";
export var unread = "_ii-f";
export var unreadIndicator = "_ii-g";